import { Decodable } from './_decodable';
import { StockMovementItem } from './stock-movement-item';

class StockMovement extends Decodable {
    static readonly TYPE_IN = 1;
    static readonly TYPE_OUT = 2;

    id?: number;
    type?: number;
    typeName?: string;
    typeClass?: string;
    date?: Date;
    notes?: string;
    originType?: string;
    originId?: number;
    originLabel?: string;
    originToken?: string;
    createdAt?: Date;
    updatedAt?: Date;

    items?: StockMovementItem[];

    protected _map = {
        date: (e: any) => this.parseDate(e),
        createdAt: (e: any) => this.parseDate(e),
        updatedAt: (e: any) => this.parseDate(e),
        items: (e: any) => StockMovementItem.parse(e),
    };
}

export { StockMovement };
